import { SignalStoreBuilder } from "src/app/_stores/SignalStoreBuilder";
import { BatteryVersion } from "src/app/_models/location/battery/BatteryVersion";

export const SignalBatteryVersionsStore =
  new SignalStoreBuilder<BatteryVersion>(
    (v) => v.id_version,
    (json) => json as BatteryVersion,
  )
    .withReload("batteries/versions")
    .withAdd("batteries/versions")
    .withUpdate((id) => `batteries/versions/${id}`, "patch")
    .withRemove((id) => `batteries/versions/${id}`)
    .withAutoRefresh((store) => store.reload())
    .providedInRoot()
    .build();

// ---------------------------------------------------------------------------

type BatteryVersionType = { type: string };

export const SignalBatteryVersionTypesStore =
  new SignalStoreBuilder<BatteryVersionType>(
    (v) => v.type,
    (json) => json as BatteryVersionType,
  )
    .withReload("batteries/versions/types")
    .withAutoRefresh((store) => store.reload())
    .providedInRoot()
    .build();
